<select
  class="text-sm bg-transparent border border-greyscale-300 rounded-md px-2 py-1 text-greyscale-600 cursor-pointer focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
  [(ngModel)]="selectedLanguage"
  (change)="onLanguageChange(selectedLanguage)"
>
  @for (lang of languages; track lang.value) {
    <option [value]="lang.value">{{ lang.label }}</option>
  }
</select>
